<h5>{{'lang.globals.playerStatus' | translate}}</h5>
<div class="widget mt-4">
  <div class="widget__info">
    <sb-info-text>
      <div class="heading">{{'lang.globals.player' | translate}}</div>
      <div class="val"><span
        class="blue mr-3">{{(networkData?.deviceStatus?.total ? networkData?.deviceStatus?.total : 0)| sbNumberFormat}}</span>
      </div>
    </sb-info-text>
  </div>
  <div class="widget__info">
    <sb-info-text>
      <div class="heading">{{'lang.globals.playerStatusOnline' | translate}}</div>
      <div class="val"><span
        class="green mr-3">{{networkData?.deviceStatus?.quotaOnlineStatus_Online + networkData?.deviceStatus?.quotaOnlineStatus_CurrentlyOffline | sbNumberFormat}}</span>
      </div>
    </sb-info-text>
  </div>
  <div class="widget__info">
    <sb-info-text>
      <div class="heading">{{'lang.dashboard.planOffline' | translate}}</div>
      <div class="val"><span
        class="orange mr-3">{{(networkData?.deviceStatus?.quotaOnlineStatus_PlannedOffline ? networkData?.deviceStatus?.quotaOnlineStatus_PlannedOffline : 0) | sbNumberFormat}}</span>
      </div>
    </sb-info-text>
  </div>
  <div class="widget__info">
    <sb-info-text>
      <div class="heading">{{'lang.globals.playerStatusOffline' | translate}}</div>
      <div class="val"><span
        class="red mr-3">{{(networkData?.deviceStatus?.quotaOnlineStatus_Offline ? networkData?.deviceStatus?.quotaOnlineStatus_Offline : 0)| sbNumberFormat}}</span>
      </div>
    </sb-info-text>
  </div>
  <div class="widget__info">
    <sb-info-text>
      <div class="heading">{{'lang.globals.unknown' | translate}}</div>
      <div class="val"><span
        class="grey mr-3">{{(networkData?.deviceStatus?.quotaOnlineStatus_Unknown ? networkData?.deviceStatus?.quotaOnlineStatus_Unknown : 0)| sbNumberFormat}}</span>
      </div>
    </sb-info-text>
  </div>
</div>
